export default "__VITE_ASSET__BRHDfNUF__"